import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../../style/theme';
const {Text, Paragraph} = Typography;
const Content = Layout;

const Cuatro = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Paragraph className='Title4' style={{color: appColors['ColorX'], marginTop: '3vh'}}><b>Value Proposition</b></Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}><ul><li>The customer won&apos;t need to go through impractical and invasive tests. The device will be able to <b>measure pro-inflammatory biomarkers</b>, since an imbalance between them will cause different consequences. Also, the response time for the results is improved, the <b>results will be easy to interpret</b>, and the distribution to the health centers will be <b>more economical</b> and frequent.</li><li>Due to its affinity and specificity, the information provided by the device will define the level of inflammation to prevent a wider range of diseases and meet the needs each person has to grow towards healthier aging.</li></ul></Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-27-primera.png'/>
          <p><b>Fig. 6.4</b> Complementary image of the <q>Value  Proposition</q> section in the Business Model Canva In the picture it is shown how our kit works.</p>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Cuatro;
